function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1248 18.8241L10.2594 19.5494V20.7582H17.954V19.5494L15.8555 18.8241V2.62633L17.954 1.90105V0.692261H10.2594V1.90105L12.1248 2.62633V9.39556H5.59606V2.62633L7.69458 1.90105V0.692261H0V1.90105L2.09852 2.62633V18.8241L0 19.5494V20.7582H7.69458V19.5494L5.59606 18.8241V11.5714H12.1248V18.8241Z",
  fill: "#231F20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.918 18.8241L20.0527 19.5494V20.7582H26.5814V19.5494L24.2497 18.8241L24.0165 8.42852V5.76918H24.2497L25.4156 7.94501L33.8096 21L35.675 20.7582L35.9082 2.62633L37.5404 1.90105V0.692261H31.2448V1.90105L33.5765 2.62633L33.8096 11.0879V13.7472H33.5765L32.4106 11.5714L25.1824 0.692261H20.0527V1.90105L22.1512 2.62633L21.918 18.8241Z",
  fill: "#231F20"
});

var SvgHn = function SvgHn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 21,
    viewBox: "0 0 38 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HN.361766d7.svg";
export { ForwardRef as ReactComponent };